import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Team } from 'src/app/core/models/project-pilot.model';
import { ConfirmationPopupComponent } from 'src/app/shared/component/confirmation-popup/confirmation-popup.component';
import { Context } from 'src/app/shared/models/context';
import { Message, PrivilegeType, TableData } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { ProjectPilotService } from 'src/app/shared/services/project-pilot.service';
import { ManageTeamComponent } from '../manage-team/manage-team.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html',
  styleUrls: ['./teams.component.scss']
})
export class TeamsComponent implements OnInit {
  @Input() isNew!: boolean; // Receiving the boolean value
  // public tableData: TableData = { content: [] } as TableData;
  public tableData: TableData = { content: [], number: 1, size: 10, totalElements: 0 } as TableData;
  public pageSizes: number[] = [];
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;
  private context: Context;
  private pageDataKey: string = 't';

  constructor(
    private modalService: NgbModal,
    private authService: AuthService,
    private commonService: CommonService,
    private dataService: DataService,
    private projectPilotService: ProjectPilotService,
  ) { }

  ngOnInit(): void {
    this.pageSizes = this.commonService.getDefaultPageSizes();
    this.tableData = this.commonService.getDefaultPageData(this.pageDataKey);
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.context = this.authService.getContextData();
    if (this.context && this.context?.companyId) {
      this.getTeams();
    }
  }

  private getTeams(clear: boolean = true, pageNumber: number = 0) {
    if (this.context?.companyId) {
      if (clear) {
        this.isLoading = true;
        this.tableData.content = [];
      }
      const pageSize = Number(this.tableData.size);
      this.projectPilotService.getTeamsByPage(pageNumber, pageSize, null, true).subscribe({
        next: (tableData: TableData) => {
          this.tableData = {
            ...tableData,
            number: pageNumber + 1,
          };
          this.tableData.size = pageSize;
          this.tableData.content = this.tableData?.content?.sort((a, b) => a.id - b.id);
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    } else {
      this.isLoading = false;
    }
  }


  public deleteTeam(team: Team, index: number) {
    if (!this.privilege.canDelete) return;
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.title = "Team deletion";
    modalRef.componentInstance.prefixMessage = "Are you sure you want to delete team";
    modalRef.componentInstance.message = team.name;
    modalRef.componentInstance.label = 'team';
    modalRef.result.then((isConfirmed: boolean) => {
      if (isConfirmed) {
        team.isDeleteInProgress = true;
        this.projectPilotService.deleteTeams(team.id).subscribe({
          next: (message: Message) => {
            if (!message.failed) {
              this.commonService.setToastr(200, message.message);
              this.tableData?.content.splice(index, 1);
              this.getTeams(false);
              team.isDeleteInProgress = false;
            } else {
              this.commonService.setToastr(500, message.message);
              team.isDeleteInProgress = false;
            }
          },
          error: (error: HttpErrorResponse) => {
            team.isDeleteInProgress = false;
          },
        });
      }
    });
  }

  public upsertTeam(team?: Team) {
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(ManageTeamComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.team = team;
    modalRef.componentInstance.context = this.context;
    modalRef.componentInstance.teams = this.tableData.content;
    modalRef.componentInstance.passEntry.subscribe((response: Message) => {
      if (!response?.failed) {
        this.getTeams(false);
      }
    })
  }

  public toggleTeamStatus(team: Team) {
    if (!this.privilege.canEdit) {
      setTimeout(() => {
        team.disabled = team.disabled;
      }, 0);
      return;
    }
    const newDisabledState = !team.disabled;
    this.projectPilotService.toggleTeamStatus(team.id, newDisabledState).subscribe({
      next: (response: Message) => {
        if (!response.failed) {
          team.disabled = newDisabledState;
          this.commonService.setToastr(
            200,
            `Team ${team.name} is now ${newDisabledState ? 'disabled' : 'enabled'}!`
          );
        }
      },
      error: (error: HttpErrorResponse) => {
        this.commonService.setToastr(500, error?.error?.name || error.error);
      }
    });
  }

  public loadTableData(e: any) {
    this.tableData.size = +this.tableData.size;
    this.tableData.number = 1;
    this.commonService.storePageData(this.pageDataKey, this.tableData.size, this.tableData.number);
    this.getTeams(true);
  }

  public onPageChange(newPage: number): void {
    this.tableData.number = newPage;
    const pageNumber = newPage - 1;
    this.getTeams(false, pageNumber);
  }

  isImageFile(url: string): boolean {
    return /\.(jpeg|jpg|gif|png|bmp|webp)$/i.test(url);
  }

}